import { createContext, useContext } from "react";

export interface CinematicScrollContext {
  /** 0..1 progress through the entire page */
  progress: number;
  /** True when reduced motion or below mobile breakpoint */
  reduced: boolean;
}

export const CinematicCtx = createContext<CinematicScrollContext>({
  progress: 0,
  reduced: false,
});

export const useCinematicScroll = () => useContext(CinematicCtx);
